import { useSelector, useDispatch } from 'react-redux';
import {
    reset,
    setTitle,
    setOpenModal,
    setCloseModal,
} from '../state/recomendacionSlice';

const useSuggestHandler = () => {

    const dispatch = useDispatch();
    const { openModal, CodeProduct } = useSelector((state) => state?.recomendacion);

    const handlerSetTitle = async (title = '') => {
        await dispatch(setTitle(title))
    };

    const handlerOpenModal = async () => {
        await dispatch(setOpenModal());
    };

    const handlerCloseModal = async () => {
        await dispatch(setCloseModal());
    };

    const handlerResetRecomendacion = () => { dispatch(reset()) }

    return {
        openModal,
        CodeProduct,
        handlerSetTitle,
        handlerOpenModal,
        handlerCloseModal,
        handlerResetRecomendacion,
    }
};

export default useSuggestHandler;